<template>
  <g>
    <path
      d="M4.5 11.0002C5.32843 11.0002 6 10.3286 6 9.50018C6 8.67176 5.32843 8.00018 4.5 8.00018C3.67157 8.00018 3 8.67176 3 9.50018C3 10.3286 3.67157 11.0002 4.5 11.0002Z"
    />
    <path
      d="M22.17 9.17015C22.17 5.26015 18.98 2.11015 15.06 2.17015C11.23 2.23015 8.07 5.54015 8.18 9.36015C8.27 12.7402 10.76 15.5202 14.01 16.0602V20.0002H6V17.0002H6.5C6.78 17.0002 7 16.7802 7 16.5002V13.0002C7 12.4502 6.55 12.0002 6 12.0002H3C2.45 12.0002 2 12.4502 2 13.0002V16.5002C2 16.7802 2.22 17.0002 2.5 17.0002H3V21.0002C3 21.5502 3.45 22.0002 4 22.0002H18C18.55 22.0002 19 21.5502 19 21.0002C19 20.4502 18.55 20.0002 18 20.0002H16V16.1202C19.47 15.7102 22.17 12.7602 22.17 9.17015Z"
    />
  </g>
</template>
